export const AccountTypeEnum = {
  Live: "live",
  Demo: "demo",
  IBWallet: "ib_wallet",
  Wallet: "wallet",
};

export const AccountServerIdEnum = {
  WALLET: 1,
  MT5: 2,
  MATCH_TRADER: 3, // LITE & PRO
};

export const AccountSwapFreeApplicationStatusEnum = {
  APPROVED: "approved",
  DECLINED: "declined",
  NOT_STARTED: "not_requested",
  PENDING: "pending",
  EXPIRED: "expired",
};
